import { Session } from "@prisma/client/index";

export function getSessionsByVenueAndTime(sessions: Session[]) {
  const now = new Date();

  // Group sessions by past/future and venue
  const result = sessions.reduce((acc, session) => {
    const sessionDate = new Date(session.datetime);
    const isPast: boolean = sessionDate < now;
    const group: string = isPast ? "past" : "future";

    // Initialize groups if they don't exist
    if (!acc[group]) {
      acc[group] = {};
    }

    // Initialize venue group if it doesn't exist
    if (!acc[group][session.venue_id]) {
      acc[group][session.venue_id] = {
        venue: session.venue,
        sessions: [],
        ticket_url: session.ticket_url,
      };
    }

    // Add session to the appropriate venue group
    acc[group][session.venue_id].sessions.push({
      datetime: session.datetime,
      id: session.id,
    });

    return acc;
  }, {});

  // Convert venue groups from objects to arrays
  return {
    past: Object.values(result.past || {}),
    future: Object.values(result.future || {}),
  };
}
